import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

const BASE_API = process.env.REACT_APP_BASE_API;

interface IAnyResponse {
  [key: string]: any;
}

interface IMessagePayload {
  lang: string;
}

export const messageSlice = createApi({
  reducerPath: 'message',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as RootState).isAuth.isAuth;
      const lang = (getState() as RootState).language.lang;
      const publicEndpoints = ['getMessage'];
      const isPublic = publicEndpoints.includes(endpoint);
      if (token && !isPublic) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Accept-Language', lang);
      return headers;
    }
  }),
  tagTypes: ['Message'],
  endpoints: (builder) => ({
    getMessage: builder.query<IAnyResponse, IMessagePayload>({
      query: (payload) => ({
        url: `/message`,
        method: 'GET'
      })
    })
  })
});

export const { useGetMessageQuery } = messageSlice;
